// extracted by mini-css-extract-plugin
export default {"root":"zftkK","scrollable":"_20cca","size-small":"_3-9zy","sizeSmall":"_3-9zy","size-medium":"_30aQJ","sizeMedium":"_30aQJ","tag-item":"-ljyI","tagItem":"-ljyI"};